<template>
  <div class="ll-member-list-item" :class="{ noBoderTop: isloading }">
    <div class="ll-member-list-item_avatar">
      <LlAvatar
        :circleSize="32"
        :email="memberData.email"
        :image="memberData.avatar"
        :textLabel="memberData.name"
      />
    </div>
    <div class="ll-member-list-item_content">
      <div
        v-if="!_isUserDisabled && !memberData.isAdministrator && _roleListLength"
        class="ll-member-list-item_dropdown"
      >
        <LvDropdownMultiCategorySelect
          v-model="memberData.characterIdList"
          outline
          placeholder="選擇"
          :menuItems="roleList"
          :disabled="_isMemberCurrentUser"
          @input="$_changeMemberCharacter($event)"
        />
      </div>
      <div
        v-if="_hasRole && !_isUserDisabled && !hideSystemClass && !memberData.isAdministrator"
        class="ll-member-list-item_dropdown"
      >
        <LvDropdownMultiSystemClasses
          v-model="memberData.systemClasses"
          title=""
          :disabled="_isMemberCurrentUser"
          :selectValue="memberData.systemClassesSelectValue"
          :propsMenuItems="multipleSystemClassMenu"
          @input="$_changeMemberSystem($event)"
          @init-value="$_initMemberSystem($event)"
        />
      </div>
      <div
        v-if="
          _hasRole &&
          !_isUserDisabled &&
          organizationFactoryList.length &&
          !memberData.isAdministrator
        "
        class="ll-member-list-item_dropdown"
      >
        <LvStateDropDownSelectMultiLayer
          v-model="_factoryIds"
          outline
          layerKey="child_factories"
          allSelectText="所有轄下單位"
          placeholder="請設定限閱轄下單位"
          :items="organizationFactoryList"
          :disabled="_isMemberCurrentUser"
          @input="$_onChangeMemberFactory($event)"
        />
      </div>
    </div>
    <div class="ll-member-list-item_condition">
      <ContentChip
        narrow
        :textLabel="memberData.condition.textLabel"
        :green="memberData.condition.value === 'using'"
        :yellow="memberData.condition.value === 'inviting'"
        :lightGray="memberData.condition.value === 'no_use'"
        :darkGray="memberData.condition.value === 'disabled'"
      />
    </div>
    <div v-if="!memberData.isAdministrator" class="ll-member-list-item_tools">
      <IconNavDrawer
        v-if="memberData.condition.value === 'disabled' || memberData.condition.value === 'no_use'"
        :navList="iconDisableNavDrawer"
        @click="$_disablenNavDrawerClick($event)"
      />
      <IconNavDrawer v-else :navList="_iconNavDrawer" @click="$_navDrawerClick($event)" />
    </div>
    <PopUp title="確定刪除此帳號嗎？" :popUpActive="deletePopupActive" @click="$_alertPopupClose()">
      <LlCancelPopupContent cancelText="被刪除的帳號將永久無法登入系統使用，請確認是否刪除帳號。">
        <LlAvatar
          :circleSize="32"
          :email="memberData.email"
          :image="memberData.avatar"
          :textLabel="memberData.name"
        />
        <template v-slot:buttons>
          <WsButton001 outLine @click="$_alertPopupClose()">
            {{ $t('取消') }}
          </WsButton001>
          <WsButton001 @click="$_deleteMemberClick()">
            {{ $t('確定') }}
          </WsButton001>
        </template>
      </LlCancelPopupContent>
    </PopUp>
    <PopUp
      title="確定停用此帳號嗎？"
      :popUpActive="disabledPopupActive"
      @click="$_disabledPopupClose()"
    >
      <LlCancelPopupContent
        cancelText="被停用的帳號所有記錄將被保存，如有需要復原必須另外提出申請。"
      >
        <LlAvatar
          :circleSize="32"
          :email="memberData.email"
          :image="memberData.avatar"
          :textLabel="memberData.name"
        />
        <template v-slot:buttons>
          <WsButton001 outLine @click="$_disabledPopupClose()">
            {{ $t('取消') }}
          </WsButton001>
          <WsButton001 @click="$_disabledMemberClick()">
            {{ $t('確定') }}
          </WsButton001>
        </template>
      </LlCancelPopupContent>
    </PopUp>
    <PopUp
      title="確定要申請讓此帳號再次啟用嗎？"
      :popUpActive="startPopupActive"
      @click="$_startPopupClose()"
    >
      <LlCancelPopupContent cancelText="當再次啟用一組停用中的帳號時，將會扣除一個使用額度。">
        <LlAvatar
          :circleSize="32"
          :email="memberData.email"
          :image="memberData.avatar"
          :textLabel="memberData.name"
        />
        <template v-slot:buttons>
          <WsButton001 outLine @click="$_startPopupClose()">
            {{ $t('取消') }}
          </WsButton001>
          <WsButton001 @click="$_startMemberClick()">
            {{ $t('申請') }}
          </WsButton001>
        </template>
      </LlCancelPopupContent>
    </PopUp>
    <PopUp
      title="確認要產生臨時密碼嗎？"
      :popUpActive="passwordPopupActive"
      @click="$_passwordPopupClose()"
    >
      <LlCancelPopupContent cancelText="產生臨時密碼後，成員無法使用舊密碼登入系統。">
        <template v-slot:buttons>
          <WsButton001 outLine @click="$_passwordPopupClose()">
            {{ $t('取消') }}
          </WsButton001>
          <WsButton001 @click="$_getTempPassword()">
            {{ $t('確定') }}
          </WsButton001>
        </template>
      </LlCancelPopupContent>
    </PopUp>
    <PopUp title="臨時密碼" :popUpActive="tempCodePopupActive" @click="$_tempCodePopupClose()">
      <div v-if="!tempPassword">
        <DotLoading />
      </div>
      <LlCancelPopupContent
        v-else
        :cancelText="$t('請將此組臨時密碼{password}複製並傳給該成員。', { password: tempPassword })"
      >
        <LlAvatar
          :circleSize="32"
          :email="memberData.email"
          :image="memberData.avatar"
          :textLabel="memberData.name"
        />
        <template v-slot:buttons>
          <WsButton001 outLine @click="$_tempCodePopupClose()">
            {{ $t('取消') }}
          </WsButton001>
          <WsButton001 @click="$_tempCodeMemberClick()">
            {{ $t('複製') }}
          </WsButton001>
        </template>
      </LlCancelPopupContent>
    </PopUp>
    <PopUp
      title="確認要寄送密碼重置信給此成員嗎？"
      :popUpActive="sendMailPopupActive"
      @click="$_sendMailPopupClose()"
    >
      <LlCancelPopupContent cancelText="此成員將在電子信箱收到信件，並進行密碼重置流程。">
        <LlAvatar
          :circleSize="32"
          :email="memberData.email"
          :image="memberData.avatar"
          :textLabel="memberData.name"
        />
        <template v-slot:buttons>
          <WsButton001 outLine @click="$_sendMailPopupClose()">
            {{ $t('取消') }}
          </WsButton001>
          <WsButton001 @click="$_sendMailClick()">
            {{ $t('確定') }}
          </WsButton001>
        </template>
      </LlCancelPopupContent>
    </PopUp>
    <PopUp
      title="確認要寄送信箱認證信給此成員嗎？"
      :popUpActive="resendVerifyEmailRequestPopupActive"
      @click="$_resendVerifyEmailRequestPopupClose()"
    >
      <LlCancelPopupContent cancelText="此成員將在電子信箱收到信件，並進行信箱認證流程。">
        <LlAvatar
          :circleSize="32"
          :email="memberData.email"
          :image="memberData.avatar"
          :textLabel="memberData.name"
        />
        <template v-slot:buttons>
          <WsButton001 outLine @click="$_resendVerifyEmailRequestPopupClose()">
            {{ $t('取消') }}
          </WsButton001>
          <WsButton001 @click="$_onResendVerifyEmailRequest">
            {{ $t('確定') }}
          </WsButton001>
        </template>
      </LlCancelPopupContent>
    </PopUp>
    <PopUp
      bottom
      title="該成員已經認證過信箱"
      :popUpActive="isActive.verifiedPopup"
      @click="$_onClosePopup('verifiedPopup')"
    >
      <template v-slot:bottomBtn>
        <WsButton001 @click="$_onClosePopup('verifiedPopup')">
          {{ $t('確定') }}
        </WsButton001>
      </template>
    </PopUp>
  </div>
</template>
<script>
import H_common from '@/helpers/common';

export default {
  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
    },
    isloading: {
      type: Boolean,
      default: false,
    },
    isAccountNumberFull: {
      type: Boolean,
      default: false,
    },
    tempPassword: {
      type: String,
      default: '',
    },
    hideSystemClass: {
      type: Boolean,
      default: false,
    },
    roleList: {
      type: Array,
      default() {
        return [];
      },
    },
    organizationFactoryList: {
      type: Array,
      default() {
        return [];
      },
    },
    multipleSystemClassMenu: {
      type: Array,
    },
  },
  data() {
    return {
      isActive: {
        verifiedPopup: false,
      },
      memberData: {
        id: 0,
        name: '',
        avatar: '',
        email: '',
        condition: 'disabled',
        character: [],
        scope: '',
        systemClasses: [],
        systemClassesSelectValue: {
          system_classes: [],
          system_subclasses: [],
          factory_system_classes: [],
          factory_system_subclasses: [],
        },
      },
      iconDisableNavDrawer: [
        {
          value: 'edit-member',
          icon: 'icon-edit-pencil',
          text: this.$t('修改成員資訊'),
        },
        {
          value: 'restart',
          icon: 'icon-check-circle-outline',
          text: this.$t('申請啟用'),
        },
        {
          value: 'temp-password',
          icon: 'icon-lock',
          text: '產生臨時密碼',
        },
        {
          value: 'delete',
          icon: 'icon-delete',
          color: 'red',
          text: this.$t('刪除此帳號'),
        },
      ],
      deletePopupActive: false,
      startPopupActive: false,
      passwordPopupActive: false,
      disabledPopupActive: false,
      sendMailPopupActive: false,
      tempCodePopupActive: false,
      resendVerifyEmailRequestPopupActive: false,
      selectedCharacters: [],
    };
  },
  computed: {
    _currentFactoryId() {
      return this.$store.state.app.factoryId;
    },
    _currentUser() {
      return this.$store.state.stone_auth.currentUser;
    },
    _iconNavDrawer() {
      let _iconNavDrawerList = [
        {
          value: 'edit-member',
          icon: 'icon-edit-pencil',
          text: this.$t('修改成員資訊'),
        },
        {
          value: 'send-email',
          icon: 'icon-send',
          text: this.$t('寄送密碼重置信'),
        },
        {
          value: 'temp-password',
          icon: 'icon-lock',
          text: this.$t('產生臨時密碼'),
        },
        {
          value: 'more-setting',
          icon: 'icon-settings-outline',
          text: this.$t('更多權限設定'),
        },
        {
          value: 'batch-scopes',
          icon: 'icon-settings-outline',
          text: this.$t('跨單位權限批次設定'),
        },
        {
          value: 'search-scope',
          icon: 'icon-settings-outline',
          text: this.$t('跨單位權限查詢'),
        },
        {
          value: 'disabled',
          icon: 'icon-disable',
          color: 'red',
          text: this.$t('停用此帳號'),
        },
        {
          value: 'delete',
          icon: 'icon-delete',
          color: 'red',
          text: this.$t('刪除此帳號'),
        },
      ];
      if (!this.memberData.emailVerifiedAt) {
        _iconNavDrawerList.splice(2, 0, {
          value: 'resend-verify-email-request',
          icon: 'icon-send',
          text: this.$t('重新發送信箱認證信'),
        });
      }
      return _iconNavDrawerList;
    },
    _selectedSendMail() {
      if (this._currentFactoryId == 1) {
        return true;
      } else return false;
    },
    _hasRole() {
      return (
        (this.selectedCharacters[0] && this.selectedCharacters[0].length > 0) ||
        (this.selectedCharacters[1] && this.selectedCharacters[1].length > 0)
      );
    },
    _factoryIds: {
      get() {
        if (this.memberData.organizationFactoryScope) {
          return this.memberData.organizationFactoryScope.factory_ids;
        } else {
          return [];
        }
      },
      set(val) {
        this.memberData.organizationFactoryScope.factory_ids = val;
      },
    },
    _isUserDisabled() {
      if (!this.memberData.condition || !this.memberData.condition.value) return true;
      return (
        this.memberData.condition.value === 'no_use' ||
        this.memberData.condition.value === 'disabled'
      );
    },
    _roleListLength() {
      let hasRole = false;
      this.roleList.forEach(role => {
        if (role.menu.length) hasRole = true;
      });
      return hasRole;
    },
    _isMemberCurrentUser() {
      return this.value.id === this._currentUser.id;
    },
  },
  watch: {
    value() {
      this.memberData = this.value;
    },
  },
  mounted() {
    this.memberData = this.value;
    this.selectedCharacters = H_common.deepCopyFunction(this.value.character).map(roleType => {
      return roleType.map(role => role.value);
    });
  },
  methods: {
    $_startMemberClick() {
      this.$emit('start');
      this.$_startPopupClose();
    },
    $_startPopupOpen() {
      this.startPopupActive = true;
    },
    $_startPopupClose() {
      this.startPopupActive = false;
    },
    $_alertPopupClose() {
      this.deletePopupActive = false;
    },
    $_alertPopupOpen() {
      this.deletePopupActive = true;
    },
    $_disabledPopupClose() {
      this.disabledPopupActive = false;
    },
    $_disabledPopupOpen() {
      this.disabledPopupActive = true;
    },
    $_passwordPopupOpen() {
      this.passwordPopupActive = true;
    },
    $_passwordPopupClose() {
      this.passwordPopupActive = false;
    },
    $_sendMailPopupOpen() {
      this.sendMailPopupActive = true;
    },
    $_sendMailPopupClose() {
      this.sendMailPopupActive = false;
    },
    $_resendVerifyEmailRequestPopupOpen() {
      this.resendVerifyEmailRequestPopupActive = true;
    },
    $_resendVerifyEmailRequestPopupClose() {
      this.resendVerifyEmailRequestPopupActive = false;
    },
    $_navDrawerClick($event) {
      if ($event === 'send-email') {
        this.$_sendEmailClick();
      } else if ($event === 'edit-member') {
        this.$_editMemberClick();
      } else if ($event === 'temp-password') {
        this.$_getPasswordClick();
      } else if ($event === 'disabled') {
        this.$_disableMemberClick();
      } else if ($event === 'delete') {
        this.$_alertPopupOpen();
      } else if ($event === 'more-setting') {
        this.$_clickFactoryScope();
      } else if ($event === 'resend-verify-email-request') {
        if (this.value.emailVerifiedAt) {
          this.$_onOpenPopup('verifiedPopup');
        } else {
          this.$_resendVerifyEmailRequestPopupOpen();
        }
      } else if ($event === 'batch-scopes') {
        this.$_goToBatchScopes();
      } else if ($event === 'search-scope') {
        this.$_goToSearchScope();
      }
    },
    $_disablenNavDrawerClick($event) {
      if ($event === 'restart') {
        this.$_startMemberClick();
      } else if ($event === 'delete') {
        this.$_alertPopupOpen();
      } else if ($event === 'temp-password') {
        this.$_getPasswordClick();
      } else if ($event === 'edit-member') {
        this.$_editMemberClick();
      }
    },
    $_deleteMemberClick() {
      this.$emit('delete');
      this.$_alertPopupClose();
    },
    $_editMemberClick() {
      this.$emit('edit-member');
    },
    $_tempCodeMemberClick() {
      this.$emit('copy-password');
    },
    $_getPasswordClick() {
      this.$_passwordPopupOpen();
    },
    $_sendEmailClick() {
      this.$_sendMailPopupOpen();
    },
    $_disableMemberClick() {
      this.$_disabledPopupOpen();
    },
    $_sendMailClick() {
      this.$emit('send-email');
      this.$_sendMailPopupClose();
    },
    $_disabledMemberClick() {
      this.$emit('disabled');
      this.$_disabledPopupClose();
    },
    $_changeMemberCharacter($event) {
      this.selectedCharacters = $event;
      this.$emit('character', $event);
    },
    $_changeMemberSystem($event) {
      this.$emit('system', $event);
    },
    $_clickFactoryScope() {
      this.$emit('click-factory-scope');
    },
    $_getTempPassword() {
      this.$emit('get-temp-password');
      this.$_tempCodePopupOpen();
      this.$_passwordPopupClose();
    },
    $_tempCodePopupOpen() {
      this.tempCodePopupActive = true;
    },
    $_tempCodePopupClose() {
      this.tempCodePopupActive = false;
    },
    $_onChangeMemberFactory($event) {
      this.$emit('factory', $event);
    },
    $_goToBatchScopes() {
      this.$emit('batch-scopes');
    },
    $_goToSearchScope() {
      this.$emit('search-scope');
    },
    $_onOpenPopup(type) {
      this.isActive[type] = true;
    },
    $_onClosePopup(type) {
      this.isActive[type] = false;
    },
    $_onResendVerifyEmailRequest() {
      this.$emit('resend-verify-email-request');
      this.$_resendVerifyEmailRequestPopupClose();
    },
    $_initMemberSystem(value) {
      this.memberData.systemClasses = value;
      this.$emit('init-system', value);
    },
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/component/ll-member-list-item';
</style>
